import { Show } from 'solid-js';
import type { Component } from 'solid-js';
import { cn } from '~/utils/classnames';
import { Skeleton } from './Skeleton';

type AvatarProps = {
  name: string;
  imgUrl?: string;
  class?: string;
  href?: string;
  loading?: boolean;
};

export const Avatar: Component<AvatarProps> = (props) => {
  const initials = () =>
    props.name
      ?.split(' ')
      .slice(0, 2)
      .map((e) => e[0])
      .join('');

  const avatarStyles =
    'flex size-10 select-none items-center justify-center rounded-full border border-magic-green bg-magic-green/30 font-semibold uppercase text-magic-green';

  const InitialsAvatar = () => <div class={cn(avatarStyles, props.class)}>{initials()}</div>;

  return (
    <Show when={!props.loading} fallback={<Skeleton class={cn('size-10 rounded-full text-sm', props.class)} />}>
      <Show when={!props.imgUrl} fallback={<img class={cn('size-10 rounded-full', props.class)} src={props.imgUrl} alt={props.name} />}>
        <Show when={props.href} fallback={<InitialsAvatar />}>
          <a href={props.href}>
            <InitialsAvatar />
          </a>
        </Show>
      </Show>
    </Show>
  );
};
